import { render, staticRenderFns } from "./EditBlockSlideshowSettingsTabs.vue?vue&type=template&id=33801840&"
import script from "./EditBlockSlideshowSettingsTabs.vue?vue&type=script&lang=js&"
export * from "./EditBlockSlideshowSettingsTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports